import { ColorProvider } from "@cinesys/ui/components";
import styled from "styled-components";
import { cinesysExperienceColors } from "@cinesys/experience-ui/theme";

/**
 * Cinesys Experience Colors, not the plain `@cinesys/ui` default (renamed 2026-09-09 from
 * `cantemoItemBrowserColors` — see that file for why) — Monday 12963206822: item-browser routes
 * are now wrapped in `ExperienceThemeProvider` (`@cinesys/experience-ui/theme`, moved out of this
 * app in Monday S2.9), so this needs to match that, not the app's OLD undecorated default (see
 * git history for the prior "adapted, not verbatim" version of this file, from before that
 * ticket).
 *
 * `ItemCard.tsx`/`AudioPreview.tsx`'s only use of this file is to re-establish CSS custom
 * properties for content React portals to `document.body` (a metadata hover panel, an audio
 * scrubber) — outside the app's own DOM subtree, so `ExperienceThemeProvider`'s scoped
 * `display: contents` override (which works by being a DOM ancestor) can't reach it. It needs its
 * own `ColorProvider` mount carrying the SAME `cinesysExperienceColors` override, or the portaled
 * content would render in the plain default palette while everything around it uses this app's.
 */
export default styled(ColorProvider)`
  ${cinesysExperienceColors}
`;
